export default {
  order: {
    type: Object,
    required: true
  }
}
